export default __webpack_public_path__ + "static/media/salary.681793dd.png";